/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import _ from 'lodash'
import { stringToDate } from './DateString'

/*
// @param {Date} startDate
// @param {Date} endDate
// @return {Number} int
*/
function calcStayingDays(startDate, endDate) {
  if (!startDate || !endDate) {
    return null
  }

  let start = _.cloneDeep(startDate)
  let end = _.cloneDeep(endDate)

  if (!start instanceof Date) {
    start = stringToDate(start)
    if (!start) {
      return null
    }
  }

  if (!end instanceof Date) {
    end = stringToDate(end)
    if (!end) {
      return null
    }
  }

  start.setHours(0, 0, 0, 0)
  end.setHours(0, 0, 0, 0)

  const diff = end.getTime() - start.getTime()

  if (diff < 0) {
    return 0
  }

  return Math.ceil(diff / 86400000)
}

/*
// @param {Date} date
// @return {Array<{Number, String}>} Dates(date, day) in the input month of date
*/
function getMonthlyDates(date) {
  const dows = ['日', '月', '火', '水', '木', '金', '土']
  const year = date.getFullYear()
  const month = date.getMonth()
  let first = new Date(year, month, 1, 0, 0)
  let end = new Date(year, month + 1, 1, 0, 0)
  const numberOfDates = (end.getTime() - first.getTime()) / (1000 * 60 * 60 * 24)

  const days = Array.apply(null, { length: numberOfDates })
    .map(Number.call, Number)
    .map(d => d + 1)
    .map(d => {
      const _date = new Date(year, month, d, 0, 0)
      return {
        date: _date,
        numberOfDate: d,
        dayOfWeek: dows[_date.getDay()]
      }
    })

  return days
}

export { calcStayingDays, getMonthlyDates }
